// add cross-domain tracking to URL
// https://www.analyticsmania.com/post/google-analytics-cross-domain-tracking-with-google-tag-manager/ &
// Outdated
/*
function decorateUrl(urlString) {
    var ga = window[window['GoogleAnalyticsObject']];

    var tracker;
    if (ga && typeof ga.getAll === 'function') {
        tracker = ga.getAll()[0];
        urlString = (new window.gaplugins.Linker(tracker)).decorate(urlString);
    }

    return urlString;
}
*/

// GA4 hacky way until they provide something.. 

function decorateUrl(urlToDecorate, crossDomain) {

    // Create fake url element with cross domain. 
    //const crossDomain = 'https://zone.eu';

    let fakeUrl = document.createElement("a");
    fakeUrl.setAttribute("type", "hidden");
    fakeUrl.setAttribute("href", crossDomain);
    fakeUrl.setAttribute("onclick", "event.preventDefault(); return false");
    document.body.appendChild(fakeUrl);

    // Emulate click
    fakeUrl.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));

    // Get href
    const urlWithLinker = fakeUrl.href;
    console.log(urlWithLinker);
    let linker = urlWithLinker.replace(crossDomain, '');
    linker = urlToDecorate + linker;
    fakeUrl.remove();

    return linker;

}
const lang = document.documentElement.lang;
let searchLabel;

switch (lang) {
    case "fi":
        searchLabel = 'Haku';
        break;
    case "et":
        searchLabel = 'Otsi';
        break;
    case "ru-RU":
        searchLabel = 'Искать';
        break;
    case "ru":
        searchLabel = 'Искать';
        break;
    default:
        searchLabel = 'Search';
}

const selectElements = document.querySelectorAll('.tld-select');
const options = {searchable: true, searchtext: searchLabel};
const checkTldGET = getQueryParam('tld');


selectElements.forEach(function(select){
    NiceSelect.bind(select, options);
});

const forms = document.querySelectorAll('.zone-advanced-domainsearch');

forms.forEach(function(form){

    if (form.querySelector('.nice-select')){
        if(checkTldGET !== null  && zoneExistingDomains.includes(checkTldGET)) {
            form.querySelector('.nice-select .current').innerHTML = "." + checkTldGET;
        }
    } else {
        if(checkTldGET !== null  && zoneExistingDomains.includes(checkTldGET)) {
            form.querySelector('.search input').value += "." + checkTldGET;
        }
    }

    inputFixAndroid = form.querySelector('.domain-input');

    if (inputFixAndroid) {
        inputFixAndroid.addEventListener("keypress", function(event) {
          if (event.key === "Enter" || event.keyCode === 13) {
            event.preventDefault(); 
            form.submit();
          }
        });
    }

    form.addEventListener("submit", function(e) {
        e.preventDefault();
        
        let targetUrl = decorateUrl(this.dataset.target, this.dataset.target);
        let domainInput = form.querySelector('.domain-input').value.replace(new RegExp(' ', 'g'), '');
        let tld = '';

        if (form.querySelector('.nice-select')) {
            tld = form.querySelector('.nice-select .current').innerHTML;
        }

        if (domainInput === '') {
            return false;
        }

        targetUrl += '#/preview/';

        if (domainInput.indexOf('.') === -1) {
            if(tld !== '') {
                targetUrl += domainInput + tld;
            } else {
                targetUrl += domainInput + '.eu';
            }
        } else {
            targetUrl += domainInput;
        }

        window.location.href = targetUrl;
        console.log(targetUrl);

        return false;

    },false);
});

function getQueryParam(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(window.location.search)) {
        return decodeURIComponent(name[1]);
    } else {
        return null;
    }
        
}